module.exports = __webpack_public_path__ + "static/media/spesa_miniatura.a5585c13.jpg";